<template>
  <form
    class="flex content-between rounded bg-sh-secondary"
    novalidate="novalidate"
    @submit.prevent="handleSearch"
  >
    <text-input
      v-bind="$attrs"
      :value="value"
      class="search"
      type="search"
      @search.native="handleSearch"
      @input="$emit('input', $event)"
    />
    <base-icon
      name="search-icon"
      type="button"
      class="sh-text-color pt-2 pb-2 bg-transparent pl-4 pr-4 cursor-pointer hover:bg-sh-button-hover hover:fill-black"
      :disabled="!value.trim()"
      @click="handleSearch"
    />
  </form>
</template>

<script>
import TextInput from '../../components/input/TextInput.vue';

export default {
  name: 'Search',
  components: {
    TextInput
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.value.trim());
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  width: 100% !important;
  &,
  &:focus {
    @apply border-none bg-sh-secondary;
  }
}
</style>
